import { TPlaceholderKeys } from '../utils/types';

export const PLACEHOLDERS: TPlaceholderKeys[] = [
    'user',
    'client',
    'model',
    'store',
    'date',
    'vehiclemodel',
    'leadname',
    'leadagent',
    'storename',
    'makeModel',
    'storeAddress',
    'storePhone',
    'storeAddressLink',
    'randomNumber',
    'useremail',
    'userphone',
];
